import request from "utils/request";

export async function getCustomSites() {
	return request("/rest/custom_sites");
}